import React, { useEffect, useState } from 'react';
import './scrollIndicator.css';

function ScrollIndicator({ refs }) {
    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            const positions = Object.values(refs).map(ref =>
                ref.current?.getBoundingClientRect().top
            );

            const screenCenter = window.innerHeight / 2;

            let newIndex = 0;
            positions.forEach((top, index) => {
                if (top < screenCenter) {
                    newIndex = index;
                }
            });

            setActiveIndex(newIndex);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [refs]);

    return (
        <div className="scroll-indicator">
            {[0, 1, 2, 3].map((i) => (
                <div
                    key={i}
                    className={`indicator-dot ${activeIndex === i ? 'active' : ''}`}
                ></div>
            ))}
        </div>
    );
}

export default ScrollIndicator;

